import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

export const HeaderGrid = styled(Grid)`
  border-bottom: 1px solid;
`;

export const VerticalTextGrid = styled(Grid)`
  text-align: center;
  -webkit-writing-mode: vertical-lr;
  writing-mode: vertical-lr;
`;

export const CheckBoxTitleGrid = styled(Grid)`
  align-content: center;
`;

export const InputFeildGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
`;
